import { Link } from 'react-router'

/**
 * Where Veriff sends the owner when they finish the ID check (TT-164) — on
 * the phone that scanned the set-up window's QR code, or on the same phone
 * when they set up from it. Outside the dashboard layouts, so it never sits
 * behind the set-up window and needs no session on the phone.
 */
export default function AccountSetupVerified() {
	return (
		<main className="flex min-h-screen items-center justify-center bg-[#FBFDFD] px-5 py-10">
			<div className="flex w-full max-w-md flex-col items-center gap-4 rounded-[20px] bg-white px-6 py-10 text-center shadow-[0px_24px_64px_0px_rgba(0,0,0,0.08)]">
				<div className="flex size-16 items-center justify-center rounded-full bg-[#E8F6ED] text-2xl text-[#16A34A]">
					✓
				</div>
				<h1 className="text-[22px] font-medium text-[#32302F]">
					Thanks, your ID was sent
				</h1>
				<p className="text-[15px] leading-[1.55] text-[#747474]">
					We are checking it now. If you started on your computer, go back to
					it: the set-up window moves on by itself to the Property Management
					Agreement.
				</p>
				<Link
					to="/dashboard"
					className="mt-2 inline-flex h-[50px] w-full items-center justify-center rounded-[30px] bg-[#32302F] text-[16px] font-medium text-white"
				>
					Continue Here
				</Link>
			</div>
		</main>
	)
}
